export const isUSLocation = (country?: string) => country === 'US'

export const isLocationOutsideUS = (country?: string) => !!country && !isUSLocation(country)
